import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import { firebaseApp } from "./fb";

import Vuesax from "vuesax";
import "vuesax/dist/vuesax.css"; //Vuesax styles
import "material-icons/iconfont/material-icons.css";

Vue.use(Vuesax, {
  colors: {
    primary:'#5b3cc4',
    success:'rgb(23, 201, 100)',
    danger:'#e82060',
    warning:'rgb(255, 130, 0)',
    dark:'rgb(36, 33, 69)'
  }
})


import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
Vue.config.productionTip = false;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

import ToggleButton from 'vue-js-toggle-button'
Vue.use(ToggleButton)

import moment from 'moment'
Vue.prototype.moment = moment


import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

Vue.use(Datetime)

import VueMask from 'v-mask'
Vue.use(VueMask);



import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB7dZRt25HvfRTlK9rehEArICUKvRGGezg',
    v: '3.26',
    libraries: 'places,drawing', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})




firebaseApp.auth().onAuthStateChanged(function(user) {
  if (user) {

    // user.sendEmailVerification().then(function() {
    //   }).catch(function(error) {
    //     // An error happened.
    //   });
    localStorage.setItem('ufb', JSON.stringify(user))
    const lvl = localStorage.getItem('l');
    console.log(lvl)
    // if(lvl==0){
    //     //admin
    //     router.push({ path: "/Home" });
    // }
    // if(lvl==1){
    //     //station
    //     router.push({ path: "/Main" });
    // }
    // if(lvl==2){
    //     //qr user
    //     router.push({ path: "/Qr" });
    // }
    // else{
    //     router.push({ path: "/Main" });
    // }
  } else {
    router.push({ path: "/" });
  }
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
